import React from 'react';
import { observer } from 'mobx-react';
import { routeNode } from 'core/routing';
import { FourOhFour } from 'apps/fourOhFour/index';
import { CheckEmail } from 'apps/profile/signUp/CheckEmail';
import { SetupProfilePage } from 'apps/profile/setupProfile';

import { ChoosePlan, Subscription } from './index';

const viewsMap = {
  choosePlan: ChoosePlan,
  checkEmail: CheckEmail,
  confirmProfile: SetupProfilePage,
  subscription: Subscription,
};

type OnboardingSpaceProps = {
  params: Record<string, any>;
  route: Record<string, any>;
  routerStore: Record<string, any>;
  componentFromRoute: Function;
};

@observer
class OnboardingSpace extends React.Component<OnboardingSpaceProps> {
  render() {
    const View = this.props.componentFromRoute();
    const RouterReview = <View params={this.props.routerStore.params} />;

    return RouterReview;
  }
}

export const OnboardingRouter = routeNode(
  'onboarding',
  viewsMap,
  FourOhFour as unknown as boolean,
)(OnboardingSpace);
